import { render, staticRenderFns } from "./PriceCardJn03.vue?vue&type=template&id=97aa6f4a&scoped=true&"
import script from "./PriceCardJn03.vue?vue&type=script&lang=js&"
export * from "./PriceCardJn03.vue?vue&type=script&lang=js&"
import style0 from "./PriceCardJn03.vue?vue&type=style&index=0&id=97aa6f4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97aa6f4a",
  null
  
)

export default component.exports